<a title="Cambiar saldo PayPal, Skrill, MercadoPago" alt="Saldoar" (click)="goToLink($event)" >
    <img width="641" height="176" src="{{cdnUrl}}assets/logo-saldo-{{color}}.svg" alt="Cambiar saldo online">
</a>

